import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ModuloAcessoInterface } from '../interfaces/moduloAcesso.interface';

@Injectable({
  providedIn: 'root',
})
export class PermissoesService {
  private permissoes: ModuloAcessoInterface[] = [];
  private rawCache = '';
  private readonly DEMO_USER_ID: number = 203;
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  constructor() {
    this.sync();
  }

  private sync(): void {
    if (!this.isBrowser) return;
    const stored = sessionStorage.getItem('modulos_acesso') ?? '';
    if (stored === this.rawCache) return;
    this.rawCache = stored;
    try {
      this.permissoes = stored
        ? (JSON.parse(stored) as ModuloAcessoInterface[])
        : [];
    } catch {
      this.permissoes = [];
    }
  }

  loadPermissions(): void {
    this.sync();
  }

  clear(): void {
    this.permissoes = [];
    this.rawCache = '';
  }

  hasPermission(name: string): boolean {
    this.sync();
    return this.permissoes.some(
      modulo => modulo.name === name && modulo.permissions !== 0
    );
  }

  IsDemoUser(id: number): boolean {
    return !(id === this.DEMO_USER_ID);
  }
}
